export default __webpack_public_path__ + "static/media/Quartermaster's Band.c9946551.jpg";